var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { observer } from 'mobx-react';
let Actor_ = class Actor_ extends React.PureComponent {
    render() {
        const { actor, structureTemplate } = this.props;
        // console.log('render Actor_', actor.tid);
        if (!actor) {
            console.warn('Kein Actor für <Actor_>');
            return null;
        }
        if (structureTemplate) {
            return this.injectChildren(actor.actorRenderer.aspectifyJsxTemplate(structureTemplate, { z: 1 })) || null;
        }
        return this.injectChildren(actor.actorRenderer.computedComponent) || null;
    }
    injectChildren(reactElement) {
        const { actor, children } = this.props;
        if (!this.props.children)
            return reactElement;
        const clone = actor.actorRenderer.aspectifyJsxTemplate(actor.actorRenderer.computedSkeleton, {
            innerChildren: children,
        });
        return clone;
    }
};
Actor_ = __decorate([
    observer
], Actor_);
export { Actor_ };
